export const BOOKING_TYPE = {
  SHARED_SPACE: 1,
  PRIVATE_OFFICE: 2,
  PRIVATE_OFFICE_ON_DEMAND: 2,
  EXCLUSIVE_OFFICE: 3,
  MEETING_ROOM: 4,
  EVENT_SPACE: 5,
  PRIVATE_OFFICE_CROSS_PRODUCT: 6,
  PRIVATE_OFFICE_ON_DEMAND_INSTANCE: 7,
  MEETING_ROOM_EXCLUSIVE_OFFICE: 8,
  EXTRA_SERVICE: 9,
};
